import OfferStatusBadge from "./OfferStatusBadge";
import OfferSummary from "./OfferSummary";
import OfferItemsTable from "./OfferItemsTable";

import {
  formatOfferDate
} from "../utils/offer.utils";

const OfferDetails = ({
  offer,
  onStatusChange,
  statusActions,
  onEditItem,
  onDeleteItem
}) => {
  if (!offer) {
    return null;
  }

  const currency =
    offer.currency || "INR";

  return (
    <div className="offer-details">
      <div className="offer-details__header">
        <div>
          <span className="offer-details__label">
            Offer
          </span>

          <h1>
            {offer.offer_number}
          </h1>

          <OfferStatusBadge
            status={offer.status}
          />
        </div>

        {statusActions}
      </div>

      <div className="offer-details__grid">
        <section className="offer-details__card">
          <h2>Client</h2>

          <p>
            <strong>
              {offer.client_name}
            </strong>
          </p>

          {offer.company_name && (
            <p>
              {offer.company_name}
            </p>
          )}

          {offer.client_email && (
            <p>
              {offer.client_email}
            </p>
          )}
        </section>

        <section className="offer-details__card">
          <h2>Query</h2>

          <p>
            <strong>
              {offer.query_subject ||
                "—"}
            </strong>
          </p>

          {offer.query_message && (
            <p>
              {offer.query_message}
            </p>
          )}
        </section>

        <section className="offer-details__card">
          <h2>Offer Information</h2>

          <p>
            Currency:{" "}
            <strong>
              {currency}
            </strong>
          </p>

          <p>
            Valid Until:{" "}
            <strong>
              {formatOfferDate(
                offer.valid_until
              )}
            </strong>
          </p>

          <p>
            Created By:{" "}
            <strong>
              {offer.created_by_name ||
                "—"}
            </strong>
          </p>

          <p>
            Created:{" "}
            <strong>
              {formatOfferDate(
                offer.created_at
              )}
            </strong>
          </p>
        </section>
      </div>

      <section className="offer-details__section">
        <h2>Items</h2>

        <OfferItemsTable
          items={offer.items || []}
          currency={currency}
          readOnly={!onEditItem}
          onEdit={onEditItem}
          onDelete={onDeleteItem}
        />
      </section>

      <section className="offer-details__section offer-details__summary">
        <OfferSummary
          subtotal={offer.subtotal}
          discountAmount={
            offer.discount_amount
          }
          taxAmount={
            offer.tax_amount
          }
          totalAmount={
            offer.total_amount
          }
          currency={currency}
        />
      </section>

      {offer.notes && (
        <section className="offer-details__section">
          <h2>Notes</h2>

          <div className="offer-details__notes">
            {offer.notes}
          </div>
        </section>
      )}
    </div>
  );
};

export default OfferDetails;